import React from "react";

const ProtejaPatrimonio = () => {
  return (
    <div className="proteja-section-wrapper">
      <h1>
        Proteja seu veículo!
      </h1>
      <p>Garanta a sua tranquilidade com proteção veicular que você pode confiar</p>
    </div>
  );
};

export default ProtejaPatrimonio;
